import Vue from 'vue'
import Router from 'vue-router'
import AppLayout from '../components/admin/AppLayout'
import AuthLayout from '../components/auth/AuthLayout'
import lazyLoading from './lazyLoading'
import multiguard from 'vue-router-multiguard'

Vue.use(Router)

const demoRoutes = []
if (process.env.NODE_ENV === 'development') {
  const VueBook = require('vue-book').default
  demoRoutes.push(
    VueBook(require.context('./..', true, /.demo.vue$/), '/demo'),
    VueBook(require.context('./../components', true, /.vue$/), '/presentation'),
  )
}

const EmptyParentComponent = {
  template: '<router-view></router-view>',
}

const authCheck = (to, from, next) => {
  next()
}

export default new Router({
  routes: [
    {
      path: '*',
      redirect: {
        name: 'login'
      },
    },
    {
      path: '/auth',
      component: AuthLayout,
      children: [
        {
          name: 'login',
          path: 'login',
          component: lazyLoading('auth/login/Login'),
        },
        {
          name: 'forgot-password',
          path: 'forgot-password/:invitation?',
          component: lazyLoading('auth/forgotPassword/forgotPassword'),
        },
        {
          path: '',
          redirect: {
            name: 'login'
          },
        },
        {
          name: 'create-password',
          path: 'create-password/:token?',
          component: lazyLoading('auth/createPassword/createPassword'),
        }
      ],
    },
    {
      name: 'RequestReimbursement',
      path: '/request-reimbursement',
      component: AppLayout,
      children: [
        {
          name: 'request-reimbursement-list',
          path: 'list',
          component: lazyLoading('requestReimbursement/RequestReimbursementList'),
          default: true
        },
        {
          name: 'request-reimbursement-create',
          path: 'create',
          component: lazyLoading('requestReimbursement/RequestReimbursementCreate'),
          beforeEnter: multiguard([authCheck])
        },
        {
          name: 'request-reimbursement-show',
          path: 'detail/:id',
          component: lazyLoading('requestReimbursement/RequestReimbursementShow'),
        },
        {
          name: 'request-reimbursement-analyze',
          path: 'result/:id',
          component: lazyLoading('requestReimbursement/analyze/RequestReimbursementAnalyze'),
        }
      ]
    },
    {
      name: 'Processes',
      path: '/processes',
      component: AppLayout,
      children: [
        {
          name: 'processes-list',
          path: 'list',
          component: lazyLoading('processes/ProcessesList'),
          default: true,
        },
        {
          name: 'processes-details',
          path: 'details',
          component: lazyLoading('processes/ProcessDetail'),
        },
        {
          name: 'processes-draft',
          path: 'draft',
          component: lazyLoading('processes/ProcessesDraft'),
        },
        {
          name: 'request-inspection',
          path: 'request-inspection',
          component: lazyLoading('processes/RequestInspection'),
        },
        {
          name: 'check-inspection',
          path: 'check-inspection',
          component: lazyLoading('processes/CheckInspection'),
        },
      ]
    },
    {
      name: 'Protest',
      path: '/protest',
      component: AppLayout,
      children: [
        {
          name: 'protest-create',
          path: 'create',
          component: lazyLoading('protest/ProtestCreate'),
          default: true,
        }
      ]
    },
    {
      name: 'Admin',
      path: '/admin',
      component: AppLayout,
      children: [
        {
          name: 'dashboard',
          path: 'dashboard',
          component: lazyLoading('dashboard/Dashboard'),
          default: true,
        },
        {
          name: 'connections',
          path: 'connections:response?',
          component: lazyLoading('connections/Connections')
        },
      ],
    },
    {
      name: 'users',
      path: '/users',
      component: AppLayout,
      children: [
        {
          name: 'users-list',
          path: 'users-list',
          component: lazyLoading('users/UsersList'),
          default: true,
        },
        {
          name: 'users-new',
          path: 'new',
          component: lazyLoading('users/UsersCreate'),
        },
        {
          name: 'users-edit',
          path: 'edit/:id',
          component: lazyLoading('users/UsersEdit'),
        }
      ]
    },
    {
      name: 'Clients',
      path: '/clients',
      component: AppLayout,
      children: [
        {
          name: 'client-list',
          path: 'list',
          component: lazyLoading('clients/ClientList'),
          default: true,
        },
        {
          name: 'client-new',
          path: 'new',
          component: lazyLoading('clients/ClientCreate'),
        },
        {
          name: 'client-edit',
          path: 'edit/:id',
          component: lazyLoading('clients/ClientEdit'),
        }
      ]
    },
    {
      name: 'Ports',
      path: '/ports',
      component: AppLayout,
      children: [
        {
          name: 'port-list',
          path: 'list',
          component: lazyLoading('ports/PortList'),
          default: true,
        },
        {
          name: 'port-new',
          path: 'new',
          component: lazyLoading('ports/PortCreate'),
        },
        {
          name: 'port-edit',
          path: 'edit/:id',
          component: lazyLoading('ports/PortEdit'),
        }
      ]
    },
    {
      name: 'SinisterCauses',
      path: '/causes',
      component: AppLayout,
      children: [
        {
          name: 'cause-list',
          path: 'list',
          component: lazyLoading('causes/CauseList'),
          default: true,
        },
        {
          name: 'cause-new',
          path: 'new',
          component: lazyLoading('causes/CauseCreate'),
        },
        {
          name: 'cause-edit',
          path: 'edit/:id',
          component: lazyLoading('causes/CauseEdit'),
        }
      ]
    },
    {
      name: 'Vessels',
      path: '/vessels',
      component: AppLayout,
      children: [
        {
          name: 'vessel-list',
          path: 'list',
          component: lazyLoading('vessels/VesselList'),
          default: true,
        },
        {
          name: 'vessel-new',
          path: 'new',
          component: lazyLoading('vessels/VesselCreate'),
        },
        {
          name: 'vessel-edit',
          path: 'edit/:id',
          component: lazyLoading('vessels/VesselEdit'),
        }
      ]
    },
    {
      name: 'Reports',
      path: '/reports',
      component: AppLayout,
      children: [
        {
          name: 'monthly-report',
          path: 'monthly-report',
          component: lazyLoading('reports/MonthlyReport'),
          default: true,
        },
        {
          name: 'open-processes-report',
          path: 'open-processes-report',
          component: lazyLoading('reports/OpenProcessesReport'),
          default: true,
        },
        {
          name: 'claims-closed-report',
          path: 'claims-closed-report',
          component: lazyLoading('reports/ClaimsClosedReport'),
          default: true,
        }
      ]
    },
    {
      name: 'Despachantes',
      path: '/custom-broker',
      component: AppLayout,
      children: [
        {
          name: 'custom-broker-list',
          path: 'list',
          component: lazyLoading('custombroker/CustomBrokerList'),
          default: true,
        },
        {
          name: 'custom-broker-new',
          path: 'new',
          component: lazyLoading('custombroker/CustomBrokerCreate'),
        },
        {
          name: 'custom-broker-edit',
          path: 'edit/:id',
          component: lazyLoading('custombroker/CustomBrokerEdit'),
        }
      ]
    },
    {
      path: '/error',
      component: EmptyParentComponent,
      children: [
        {
          name: 'error',
          path: 'error',
          component: lazyLoading('pages/404-pages/VuesticPageNotFoundSimple')
        },
      ]
    },
    {
      path: '/pages',
      component: AppLayout,
      children: [
        {
          name: 'manual',
          path: 'manual',
          component: lazyLoading('pages/terms/TermsOfUse')
        }
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js